import * as React from 'react';

/**
 * @return {React.ReactElement}
 * @constructor
 */
export default function Trash(): React.ReactElement {
  return (
    <svg width="60" height="60" viewBox="0 0 60 60" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#direct_download)">
        <path
          d="M29.9996 40.0003C29.4871 40.0003 28.9971 39.7903 28.6446 39.4203L15.5196 25.6703C14.3821 24.4803 15.2271 22.5003 16.8746 22.5003H23.7496V8.12531C23.7496 6.40281 25.1521 5.00031 26.8746 5.00031H33.1246C34.8471 5.00031 36.2496 6.40281 36.2496 8.12531V22.5003H43.1246C44.7721 22.5003 45.6171 24.4803 44.4796 25.6703L31.3546 39.4203C31.0021 39.7903 30.5121 40.0003 29.9996 40.0003V40.0003Z"
        />
        <path
          d="M55.625 55H4.37499C1.96249 55 -7.62939e-06 53.0375 -7.62939e-06 50.625V49.375C-7.62939e-06 46.9625 1.96249 45 4.37499 45H55.625C58.0375 45 60 46.9625 60 49.375V50.625C60 53.0375 58.0375 55 55.625 55Z"
        />
      </g>
      <defs>
        <clipPath id="direct_download">
          <rect
            width="60"
            height="60"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
